<template>
    <div>
        <div class="row">
            <div class="col">
                <div class="page-bar">
                    <div class="page-title-breadcrumb">
                        <div class="row">
                            <div class="col">
                                <div class="abtg__bc-wrapper">
                                    <div class="home">
                                        <a class="parent-item" href="/dashboard">
                                            <i class="fas fa-home"></i></a>&nbsp;
                                    </div>

                                    <div class="arrow" style="padding-left:10px !important;"><img src="/img/bread-arrow.png"></div>

                                    <span v-for="(bl, index) in content.bread_list">
                                        <div class="link">
                                            <a class="parent-item" :href="bl.url"
                                               v-if="bl.url">{{bl.label}}</a>

                                        </div>
                                             <div class="arrow"><img src="/img/bread-arrow.png"></div>
                                        </span>



                                        <div class="link"><strong>{{content.bread_active.label}}</strong></div>
                                        <div class="arrow"><img src="/img/bread-arrow.png"></div>

                                </div>

                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    export default {
        props: ['content'],
        components: { },
        data: function () {
            return {
            }
        },
        computed: {
        },
        created: function () {
        },
        methods: {
        }
    }
</script>